/** The app's version, from package.json at build time (for example 1.0.0). */
export const appVersion: string = __APP_VERSION__
